import {
  IsDefined,
  IsInt,
  IsOptional,
  IsString
} from 'class-validator';
import { Type } from 'class-transformer';

export class CheckStockNameExistsDto {
  @IsDefined()
  @IsString()
  @Type(() => String)
  name: string;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantId: number

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  stockId?: number
}